import { gql } from 'urql';

export const Q_VEHICULOS = gql`
  query Vehiculos($q: String, $page: Int, $limit: Int) {
    vehiculos(q: $q, page: $page, limit: $limit) {
      items {
        id
        patente
        marca
        modelo
        estado
        cliente_id
        cliente {
          id
          nombre
        }
      }
      pageInfo {
        page
        limit
        total
      }
    }
  }
`;

export const M_DELETE_VEHICULO = gql`
  mutation DeleteVehiculo($id: ID!) {
    deleteVehiculo(id: $id)
  }
`;
